import StatusHandler from 'app/shared-components/StatusHandler'

import useGetOpportunityById from 'app/requests/Opportunity/hooks/useGetOpportunityById'
import {
    WithId,
} from 'app/types/common.types'
import OpportunitiesForm from '../OpportunitiesForm'

const OpportunitiesOverview = ({
    id,
}: Readonly<WithId<number>>) => {
    const {
        data,
        isDataReady,
        isError,
        error,
        isFetching,
    } = useGetOpportunityById(id)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <OpportunitiesForm
                disabled
                data={data}
                exists
            />
        </StatusHandler>
    )
}

export default OpportunitiesOverview
